// 📄 components/StepCCVirtualHost.tsx
import React from 'react';
import { GeneralsFormData } from '../../../../../services/commerce/integrationService.ts';

interface StepCCVirtualHostProps {
  ccMasterHost: string;
  ccVirtualHost: string;
  ccMasterPort: string;
  ccVirtualPort: string;
  ccProtocol: string;
  onChange: (field: keyof GeneralsFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepCCVirtualHost({
  ccMasterHost,
  ccVirtualHost,
  ccMasterPort,
  ccVirtualPort,
  ccProtocol,
  onChange,
  isInvalid
}: StepCCVirtualHostProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-indigo-500/5 border border-indigo-500/10 rounded-xl p-3 space-y-1">
        <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest block">SAP Cloud Connector GUI</span>
        <p className="font-mono text-xs text-gray-300">
          <span>Cloud Connector → Subaccount → Cloud To On-Premise → Access Control</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-indigo-400">1. Master & Virtual Host Mapping</h3>
        <p className="text-sm text-gray-400 mt-1">
          Mapea la dirección de host interno (Master Host) de tu servidor SAP ERP a un nombre de host virtual (Virtual Host) seguro.
          El host virtual será el expuesto hacia SAP Integration Suite (BTP) sin revelar tu infraestructura interna.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">
              Back-End System Protocol
            </label>
            <select
              value={ccProtocol}
              onChange={(e) => onChange('ccProtocol', e.target.value)}
              className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-indigo-500"
            >
              <option value="HTTP">HTTP (Sin cifrar)</option>
              <option value="HTTPS">HTTPS (Seguro - Recomendado)</option>
              <option value="RFC">RFC (SNC - Conexión RFC directa)</option>
              <option value="RFC_SNC">RFC con SNC (Secure Network Communications)</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">
              Internal / Master Host (SAP Server IP/Domain) <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              value={ccMasterHost}
              onChange={(e) => onChange('ccMasterHost', e.target.value)}
              placeholder="ej. s4hana.internal.corp"
              className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-indigo-500 ${
                isInvalid && !ccMasterHost ? 'border-red-500' : 'border-white/10'
              }`}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">
              Internal / Master Port <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              value={ccMasterPort}
              onChange={(e) => onChange('ccMasterPort', e.target.value.replace(/\D/g, ''))}
              placeholder="ej. 44300 o 8000"
              maxLength={5}
              className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-indigo-500 ${
                isInvalid && !ccMasterPort ? 'border-red-500' : 'border-white/10'
              }`}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">
              Virtual Host Name <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              value={ccVirtualHost}
              onChange={(e) => onChange('ccVirtualHost', e.target.value)}
              placeholder="ej. sap-prd-virtual"
              className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-indigo-500 ${
                isInvalid && !ccVirtualHost ? 'border-red-500' : 'border-white/10'
              }`}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-400 mb-1">
              Virtual Port <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              value={ccVirtualPort}
              onChange={(e) => onChange('ccVirtualPort', e.target.value.replace(/\D/g, ''))}
              placeholder="ej. 443"
              maxLength={5}
              className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-indigo-500 ${
                isInvalid && !ccVirtualPort ? 'border-red-500' : 'border-white/10'
              }`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
